import { ReactNode } from "react";
import { FieldValues } from "react-hook-form";

import { InputTooltip } from "./InputTooltip";

type InputTooltipProps<T extends FieldValues> = {
  text: string | React.ReactNode;
  tooltip: ReactNode;
  /** Forwarded to InputTooltip; omitted means inherit. */
  tooltipIconColor?: string;
};

export const TextWithTooltip = <T extends FieldValues>({
  text,
  tooltip,
  tooltipIconColor,
}: InputTooltipProps<T>) => {
  return (
    <span style={{ display: "inline-flex", alignItems: "center" }}>
      {text}
      <InputTooltip title={tooltip} iconColor={tooltipIconColor} />
    </span>
  );
};
